<template>
  <div class="preloader" :class="{ center_position: position === 'center' }">
    <div class="preloader__spinner" :class="`preloader__spinner_${size}`"></div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  color: {
    type: String,
    default: "var(--general-color)",
  },
  position: {
    type: String,
    default: "", // center
  },
  size: {
    type: String,
    default: "", // sm
  },
});

const colorState = computed(() => props.color);
</script>

<style lang="scss" scoped>
.preloader {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

// the ring of the global .spinner: a faint track with a coloured head
.preloader__spinner {
  border: 5px solid var(--general-opacity-color);
  border-color: color-mix(in srgb, v-bind(colorState) 30%, transparent);
  border-top-color: v-bind(colorState);
  border-radius: 50%;
  width: 56px;
  height: 56px;
  animation: spin 1s cubic-bezier(0.55, 0.15, 0.45, 0.85) infinite;
  z-index: 100;
  &_sm {
    border-width: 2.5px;
    width: 18px;
    height: 18px;
  }
}

.center_position {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
